module.exports = __webpack_public_path__ + "img/10.55feef4d.jpg";